<div class="img_wrap1">
  <span class="btn-like" (click)="toggleOfficePanel()">
    <img
      src="../../../../assets/img/city_icon.svg"
      alt="icon"
      class="icon"
      />
    {{ getSelectedCompanyName() }}
  </span>
</div>



@if (showOfficePanel) {
  <div
    class="notification-panel img_wrap1"
    (clickOutside)="closeOfficePanel()"
    >
    <table>
      @for (option of groupOffices; track option) {
        <tr [ngTemplateOutlet]="treeTemplate" [ngTemplateOutletContext]="{ $implicit: option, level: 1 }"></tr>
      }
      <ng-template #treeTemplate let-option let-level="level">
        <tr>
          <td class="property-column m-2" [ngStyle]="{ 'padding-left.px': level * 4 }">
            <span class="d-flex justify-content-between w-100">
              <span> @if (!option.is_parent) {
                <img
                  src="../../../../assets/img/right-corner.svg"
                  alt=""
                  class="icon"
                  (click)="setDefaultOffice(option.id); $event.stopPropagation()"
                  />
              } {{ option.name }}</span>
              @if (option.id != currentCompanyId) {
                <img
                  src="../../../../assets/img/select-office.svg"
                  alt=""
                  class="icon"
                  (click)="setDefaultOffice(option.id); $event.stopPropagation()"
                  />
              }
              @if (option.id == currentCompanyId) {
                <img
                  style="width: 25px;"
                  src="../../../../assets/img/default-office.svg"
                  alt=""
                  class="icon"
                  (click)="setDefaultOffice(option.id); $event.stopPropagation()"
                  />
              }
            </span>
          </td>
          <td
            class="value-column"
    [ngClass]="{
      'green-c': lastSelectedOffices.includes(option.id),
      'red-c': !lastSelectedOffices.includes(option.id)
    }"
            (click)="selectOffice(option.id); $event.stopPropagation()"
            >
            @if (lastSelectedOffices.includes(option.id)) {
              <img
                src="../../../../assets/img/check.svg"
                alt=""
                class="icon"
                />
            }
            @if (!lastSelectedOffices.includes(option.id)) {
              <img
                src="../../../../assets/img/cross.svg"
                alt=""
                class="icon"
                />
            }
          </td>
        </tr>
        @if (option.children && option.children.length > 0) {
          @for (child of option.children; track child) {
            <tr
              [ngTemplateOutlet]="treeTemplate"
              [ngTemplateOutletContext]="{ $implicit: child, level: level + 1 }"
            ></tr>
          }
        }
      </ng-template>
    </table>
  </div>
}
